import {inject, Injectable} from "@angular/core";
import {WrapperDto} from "../../dto/wrapper.dto";
import {OrgDto} from "../../dto/org.dto";
import {UrlBuilder} from "../../item/url.item";
import {HttpClient} from "@angular/common/http";
import {Observable, tap} from "rxjs";
import {SearchRequest} from "../../dto/search/search-table.dto.req";
import {map} from "rxjs/operators";
import {VehicleRepairDto} from "../../dto/vehicle/vehicle-repair.dto";
import {VoidDto} from "../../dto/void.dto";
import {VehicleHistoryDto} from "../../dto/vehicle/vehicle-history.dto";
import {SearchVehicleRepairRes} from "../../dto/vehicle/search-vehicle-repair.res";
import {isUuid} from "../../../libs/utils/epic.utils";


@Injectable({providedIn: 'root'})
export class VehicleRepairRepo {

  private readonly vrRead = '/v1/org/{orgId}/vehicle/{vehicleId}/repair/{id}';
  private readonly vrWrite = '/v1/org/{orgId}/vehicle/{vehicleId}/repair';
  private readonly vrDelete = '/v1/org/{orgId}/vehicle/{vehicleId}/repair/{id}/delete';
  private readonly vrComplete = '/v1/org/{orgId}/vehicle/{vehicleId}/repair/{id}/complete';
  private readonly vrSearch = '/v1/org/{orgId}/vehicle/{vehicleId}/repair/search';

  private readonly http: HttpClient = inject(HttpClient);

  public getById(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VehicleRepairDto>> {
    const url = UrlBuilder.builder().addPath(this.vrRead).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.get<WrapperDto<VehicleRepairDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public update(org: OrgDto, vehicleId: string, vr: VehicleRepairDto): Observable<WrapperDto<VehicleRepairDto>> {
    const url = UrlBuilder.builder().addPath(this.vrWrite).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<VehicleRepairDto>>(url.getUrl(), vr, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public delete(org: OrgDto, id: string, vehicleId: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.vrDelete).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public complete(org: OrgDto, id: string, vehicleId: string, vh: VehicleHistoryDto): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.vrComplete).addParam('orgId', org.id)
      .addParam('vehicleId', vehicleId).addParam('id', id).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), vh, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  // ##########################################################################
  // #### Search
  // ##########################################################################

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchVehicleRepairRes>> {
    const vehicleId = request.filters.find((f) => f.pos === 1001)?.selected?.find((s) => isUuid(s));
    const url = UrlBuilder.builder().addPath(this.vrSearch).addParam('orgId', org.id).addParam('vehicleId', vehicleId).build();
    return this.http.post<WrapperDto<SearchVehicleRepairRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchVehicleRepairRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }
}
